import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

export const InMailSendModeValues = ['users', 'all', 'organizations'] as const;

export const schemaInMail = z
  .object({
    title: z.string().min(1, 'Title is required.').max(200, 'Maksymalna liczba znaków to 200'),
    content: z.string().min(1, 'Content is required.').max(5000, 'Maksymalna liczba znaków to 5000'),
    image: z.string().optional(),
    mode: z.enum(InMailSendModeValues),
    sendTo: z.array(z.string()),
    organizationIds: z.array(z.string()),
  })
  .superRefine((val, ctx) => {
    if (val.mode === 'users' && val.sendTo.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['sendTo'],
        message: 'Select at least one user',
      });
    }
    if (val.mode === 'organizations' && val.organizationIds.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['organizationIds'],
        message: 'Select at least one organization',
      });
    }
  });

export type InMailFormEntity = z.infer<typeof schemaInMail>;

const inMailResolver: Resolver<InMailFormEntity> = zodResolver(schemaInMail) as never;

export const InMailFormOptions: UseFormProps<InMailFormEntity> = {
  mode: 'onSubmit',
  resolver: inMailResolver,
};
